/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RuoloAccessoOutputDtoFromJSON, RuoloAccessoOutputDtoToJSON, } from './RuoloAccessoOutputDto';
/**
 * Check if a given object implements the UtenteRuoloAccessoOutputDto interface.
 */
export function instanceOfUtenteRuoloAccessoOutputDto(value) {
    return true;
}
export function UtenteRuoloAccessoOutputDtoFromJSON(json) {
    return UtenteRuoloAccessoOutputDtoFromJSONTyped(json, false);
}
export function UtenteRuoloAccessoOutputDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'utente': json['utente'] == null ? undefined : json['utente'],
        'ruoloAccesso': json['ruoloAccesso'] == null ? undefined : RuoloAccessoOutputDtoFromJSON(json['ruoloAccesso']),
    };
}
export function UtenteRuoloAccessoOutputDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'utente': value['utente'],
        'ruoloAccesso': RuoloAccessoOutputDtoToJSON(value['ruoloAccesso']),
    };
}
